import React from 'react';
import { useTranslate } from 'react-admin';
import { InfoBox } from './InfoBox';
import { PlaceSearch } from './PlaceSearch';

interface PlaceSearchPanelProps {
  terminalId: number;
  onSearch: (placeIds: number[]) => void;
}

export const PlaceSearchPanel: React.FC<PlaceSearchPanelProps> = ({ terminalId, onSearch }) => {
  const translate = useTranslate();
  return (
    <InfoBox title={translate('osfc.storage_ui.place_search.title')} style={{ marginBottom: '15px' }}>
      <PlaceSearch
        terminalId={terminalId}
        onSearch={onSearch}
        searchFields={['address', 'old_address', 'ceel_number', 'sscc']}
        placeholder={translate('osfc.storage_ui.place_search.placeholder')}
      />
    </InfoBox>
  );
};
